import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, Field, useFormik } from "formik";
import CustomDatePicker from "common/CustomDatePicker";
import CustomSelect from "components/Common/custom-select";
import Swal from "sweetalert2";
import * as Yup from "yup";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col, Input, Container, Card, CardBody } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Breadcrumbs from "components/Common/Breadcrumb";
import { fetchCategories, fetchDepartments, fetchDesignations, fetchShifts,fetchEmployeeShiftRemove,fetchEmployees,removeEmployeeShift, fetchEmployeeDropdownAutoList } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import TableContainer from "components/Common/TableContainer";
import { Checkbox } from "@mui/material";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";
let selecteddata = [];

const ShiftRemoval = () => {  
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const [authDetails, setAuthDetails] = useState(null);
  const [selectedShifts, setSelectedShifts] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [shiftData, setShiftData] = useState([]);


  const dispatch = useDispatch()
  const {
    categories,
    departments,
    shifts,
    employees,
    designations,
    removeList,
    dropdownAutoList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    designations: state.DesignationMaster?.designations,
    removeList: state.AttendanceBiometricReducer?.employeeRemoveShift ?? [],
    employees: state.EmployeeDetailsReducer?.employees ?? [],
    shifts: state.shiftReducer || {},
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],

    loading: state.CategoryMaster?.loading,
    error: state.AttendanceTimeDeductionsReducer?.error,
    success: state.AttendanceBiometricReducer?.success
  })); 

  useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchDepartments(unitId));
    dispatch(fetchCategories(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchShifts(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId))
  }, [dispatch]);

  // Validation Schema using Yup
  const validationSchema = Yup.object().shape({
    fromDate: Yup.date().nullable().required("From Date is required"),
    toDate: Yup.date().nullable().required("To Date is required").min(Yup.ref("fromDate"), "To Date cannot be before From Date"),
  });

  const formik = useFormik({
    initialValues: {
      category: [],
      department: [],
      designation: [],
      employee: [],
      shift: null,
      fromDate: "",
      toDate: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("cat_id", values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0');
      formData.append("dept_id", values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0');
      formData.append("desig_id", values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0');
      formData.append("emp_id", values.employee?.value || "0");
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      formData.append("is_delete", 0);

      dispatch(fetchEmployeeShiftRemove(formData));
    },
  });

  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };
  
  // let shiftData = [];
  // shiftData = removeList.map(emp => ({
  //   emp_id: emp.emp_id,
  //   shift_date: emp.shift_date,
  //   Code: emp.emp_no,
  //   Name: emp.emp_name,
  //   Category: emp.emp_category,
  //   Designation: emp.designation,
  //   Department: emp.department,
  //   Date: emp.shift_displaydate,
  //   ShiftCode: emp.shift_code,
  //   ShiftName: emp.shift_name
  // }));

  useEffect(() => {
    if (removeList && removeList.length > 0) {
      const preparedData = removeList.map(emp => ({
        emp_id: emp.emp_id,
        shift_date: emp.shift_date,
        Code: emp.emp_no,
        Name: emp.emp_name,
        Category: emp.emp_category,
        Designation: emp.designation,
        Department: emp.department,
        Date: emp.shift_displaydate,
        ShiftCode: emp.shift_code,
        ShiftName: emp.shift_name,
      }));

      setShiftData(preparedData);

    } else {
      // Empty → clear data
      setShiftData([]);
    }
  }, [removeList]);


  // Function to handle "Select All" checkbox
  // const handleOptionChange = (eve, row1) => {
  //   const isChecked = eve.target.checked;
  //   const updatedData = shiftData.map((row) => {
  //     if (row1.original.emp_id === row.emp_id) {
  //       let emp_id = row.emp_id
  //       let shift_date = row.shift_date
  //       if (isChecked) {
  //         if (!selecteddata.some(item => item.emp_id === emp_id)) {
  //           selecteddata.push({ emp_id,shift_date });
  //         }
  //       } else {
  //         selecteddata = selecteddata.filter(item => item.emp_id !== emp_id);
  //       }
  //       //console.log("selecteddata>>>>>>", selecteddata)
  //     }
  //   });
  // };

  const handleSelectedRowsChange = React.useCallback((rows) => {
    setSelectedRows(rows);
  }, []);
 
  const columns = [ 
    // {id: "selection",Header: <input type="checkbox" />,className: "serial-no text-center",Cell: ({ row }) => <input type="checkbox" onChange={(e) => handleOptionChange(e, row)} />,},
    {
      id: "selection",
      className: "serial-no",
      applyHeaderClass: true,
      Header: ({ getToggleAllRowsSelectedProps }) => (
        <div className="text-center">
          <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
        </div>
      ),
      Cell: ({ row }) => (
        <div className="text-center">
          <input type="checkbox" {...row.getToggleRowSelectedProps()} />
        </div>
      ),
    },
    // { Header: "S.No", Cell: ({ row }) => row.index+1, className: "serial-no", applyHeaderClass: true, },
    { Header: "S.No", Cell: ({ row }) => shiftData.length - row.index, className: "serial-no", applyHeaderClass: true,},
    { Header: "Code", accessor: "Code", },
    { Header: "Name", accessor: "Name", },
    { Header: "Category", accessor: "Category", },
    { Header: "Designation", accessor: "Designation", },
    { Header: "Department", accessor: "Department", },
    { Header: "Date", accessor: "Date", },
    { Header: "Shift Code", accessor: "ShiftCode", },
    { Header: "Shift Name", accessor: "ShiftName", },
  ];

  const handleRemove = async (e) => {
      e.preventDefault();

      if (selectedRows.length === 0) {
          Swal.fire({
              icon: "warning",
              title: "No Selection",
              text: "Please select at least one before proceeding.",
          });
          return;
      }

      // 🔥 Confirmation popup
      const resultConfirm = await Swal.fire({
          title: "Are you sure?",
          text: "Do you want to remove selected employee shift(s)?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Remove",
          cancelButtonText: "Cancel",
      });

      // ❌ User clicked Cancel
      if (!resultConfirm.isConfirmed) return;

      // ✅ User clicked Yes
      let result = { shi: selectedRows };

      const formData = new FormData();
      formData.append("lst_employee_shiftremove", JSON.stringify(result));
      formData.append("create_by", authDetails?.user_id);

      dispatch(removeEmployeeShift(formData));

      formik.resetForm();
  };


  const handleCancel = () => {
      formik.resetForm()
      setSelectedRows([])
      setShiftData([])
      //dispatch(resetAll)
    }
  
    useEffect(() => {
      if (success) {
        handleCancel()
      }
    }, [authDetails, success, dispatch]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid>
          <Breadcrumbs title="Shift Management" breadcrumbItem="Shift Removal" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <form onSubmit={formik.handleSubmit}>
                    <Row>
                      {/* Category */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>Category</Label>
                          <CustomSelect
                            id="category"
                            name="category"
                            options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                            value={
                              categories
                                .filter(cat => formik.values.category?.includes(cat.empCatgryid))
                                .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                            }
                            onChange={val => formik.setFieldValue('category', val ? val.map(v => v.value) : [])}
                            isMulti
                            onBlur={formik.handleBlur}
                            className={`${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}hrms-select`}
                            classNamePrefix="hrms-select"
                            styles={SelectcustomStyles}
                          />
                          {formik.errors.category && formik.touched.category && (
                            <div className="text-danger">{formik.errors.category}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Department */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>Department</Label>
                          <CustomSelect
                            id="department"
                            name="department"
                            options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                            value={
                              departments
                                .filter(dept => formik.values.department?.includes(dept.departmentId))
                                .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                            }
                            onChange={val => formik.setFieldValue('department', val ? val.map(v => v.value) : [])}
                            isMulti
                            onBlur={formik.handleBlur}
                            className={`${formik.touched.department && formik.errors.department ? 'is-invalid' : ''} hrms-select`}
                            classNamePrefix="hrms-select"
                            styles={SelectcustomStyles}

                          />
                          {formik.errors.department && formik.touched.department && (
                            <div className="text-danger">{formik.errors.department}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Designation */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>Designation</Label>
                          <CustomSelect
                            id="designation"
                            name="designation"
                            options={designations.map(desig => ({ value: desig.desig_id, label: desig.designation }))}
                            value={
                              designations
                                .filter(desig => formik.values.designation?.includes(desig.desig_id))
                                .map(desig => ({ value: desig.desig_id, label: desig.designation }))
                            }
                            onChange={val => formik.setFieldValue('designation', val ? val.map(v => v.value) : [])}
                            isMulti
                            onBlur={formik.handleBlur}
                            className={`${formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''} hrms-select`}
                            classNamePrefix="hrms-select"
                            styles={SelectcustomStyles}

                          />
                          {formik.errors.designation && formik.touched.designation && (
                            <div className="text-danger">{formik.errors.designation}</div>
                          )}
                        </FormGroup>
                      </Col>
                      {/* Employee Code */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>Employee Code</Label>
                          <CustomSelect
                            id="employee"
                            name="employee"
                            options={dropdownAutoList.map(emp => ({ value: emp.emp_id, label: emp.emp_no }))}
                            value={formik.values.employee || null}  // Store full object
                            onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                          />
                          {formik.errors.employee &&
                            formik.touched.employee && (
                              <div className="text-danger">
                                {formik.errors.employee}
                              </div>
                            )}
                        </FormGroup>
                      </Col>

                      {/* From Date */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>
                            From Date <span className="text-danger">*</span>
                          </Label>
                          <CustomDatePicker
                            name="fromDate"
                            value={formik.values.fromDate || null}
                            selected={formik.values.fromDate}
                            onChange={date => formik.setFieldValue("fromDate", date || null)}
                            onBlur={() => formik.setFieldTouched("fromDate", true)}
                          />
                          {formik.errors.fromDate && formik.touched.fromDate && (
                            <div className="text-danger">{formik.errors.fromDate}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* To Date */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>
                            To Date <span className="text-danger">*</span>
                          </Label>
                          <CustomDatePicker
                            name="fromDate"
                            value={formik.values.toDate || null}
                            selected={formik.values.toDate}
                            onChange={date => formik.setFieldValue("toDate", date || null)}
                            onBlur={() => formik.setFieldTouched("toDate", true)}
                          />
                          {formik.errors.toDate && formik.touched.toDate && (
                            <div className="text-danger">{formik.errors.toDate}</div>
                          )}
                        </FormGroup>
                      </Col>
                    {/* </Row>

                    <Row> */}
                       <Col className="d-flex align-items-center justify-content-end">
                        {/* Search Button */}
                        <Button type="submit" className="btn button-search me-2">
                          <i className="fas fa-search me-1" /> Search
                        </Button>

                        {/* Cancel Button */}
                        <Button type="button" onClick={handleCancel} className="btn button-cancel me-2"> <i className="fas fa-sync me-1" /> Cancel
                        </Button>
                        {canDelete && (
                          <Button type="button" className="btn button-delete" onClick={handleRemove}>
                            <i className="fas fa-trash me-1" />Remove
                          </Button>
                        )}                        
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={shiftData && shiftData.length > 0 ? shiftData : []}
                    onSelectedRowsChange={handleSelectedRowsChange}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ShiftRemoval;
